export default __webpack_public_path__ + "static/media/rnr-sports-table-5.27f0b450.webp";